var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMetaMask(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 29,
    viewBox: "0 0 31 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 2285"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M27.8666 0.742676L16.6943 9.34524L18.7721 4.26832L27.8666 0.742676Z",
    fill: "#E17726",
    stroke: "#E17726",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M2.0459 0.740234L13.15 9.41331L11.1744 4.26588L2.0459 0.740234Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M23.8422 20.6606L20.8447 25.385L27.2483 27.2183L29.0536 20.7664L23.8422 20.6606Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M0.887695 20.7664L2.69296 27.2183L9.06249 25.385L6.09913 20.6606L0.887695 20.7664Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M8.72531 12.6925L6.9541 15.4777L13.2555 15.7598L13.0511 8.7085L8.72531 12.6925Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M21.2206 12.6961L16.8267 8.6416L16.6904 15.7634L22.9918 15.4813L21.2206 12.6961Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M9.05957 25.3841L12.8745 23.4803L9.57049 20.8008L9.05957 25.3841Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M17.0674 23.4803L20.8482 25.3841L20.3373 20.8008L17.0674 23.4803Z",
    fill: "#E27625",
    stroke: "#E27625",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M20.8492 25.3833L17.0684 23.4795L17.3749 26.018L17.3409 27.1109L20.8492 25.3833Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M9.06641 25.3833L12.6088 27.1109L12.5748 26.018L12.8813 23.4795L9.06641 25.3833Z",
    fill: "#D5BFB2",
    stroke: "#D5BFB2",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M12.6785 19.1092L9.51074 18.1573L11.7247 17.0996L12.6785 19.1092Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M17.2754 19.1092L18.1951 17.0996L20.4431 18.1573L17.2754 19.1092Z",
    fill: "#233447",
    stroke: "#233447",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M9.06688 25.386L9.61186 20.6616L6.10352 20.7674L9.06688 25.386Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M20.3418 20.6616L20.8527 25.386L23.8501 20.7674L20.3418 20.6616Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M22.9996 15.4761L16.6982 15.7581L17.2773 19.1075L18.197 17.0979L20.445 18.1556L22.9996 15.4761Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M9.50872 18.1556L11.7227 17.0979L12.6765 19.1075L13.2555 15.7581L6.9541 15.4761L9.50872 18.1556Z",
    fill: "#CC6228",
    stroke: "#CC6228",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M6.9541 15.4761L9.57685 20.7998L9.50872 18.1556L6.9541 15.4761Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M20.443 18.1556L20.3408 20.7998L22.9976 15.4761L20.443 18.1556Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M13.2519 15.7563L12.6729 19.1057L13.3881 23.0897L13.5585 17.8365L13.2519 15.7563Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M16.6972 15.7563L16.3906 17.8365L16.5269 23.0897L17.2762 19.1057L16.6972 15.7563Z",
    fill: "#E27525",
    stroke: "#E27525",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M17.2738 19.1126L16.5244 23.0965L17.0694 23.4844L20.3393 20.8049L20.4415 18.1606L17.2738 19.1126Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M9.51074 18.1606L9.57886 20.8049L12.8828 23.4844L13.3938 23.0965L12.6785 19.1126L9.51074 18.1606Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M17.3434 27.1157L17.3774 26.0228L17.0709 25.776H12.8472L12.5748 26.0228L12.6088 27.1157L9.06641 25.3882L10.2926 26.4459L12.8132 28.2439H17.105L19.6255 26.4459L20.8517 25.3882L17.3434 27.1157Z",
    fill: "#C0AC9D",
    stroke: "#C0AC9D",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M17.0664 23.4869L16.5215 23.0991H13.3878L12.8769 23.4869L12.5703 26.0254L12.8428 25.7786H17.0664L17.373 26.0254L17.0664 23.4869Z",
    fill: "#161616",
    stroke: "#161616",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M28.3428 9.9069L29.2965 5.14728L27.8659 0.740234L17.0684 9.06075L21.2239 12.6922L27.0825 14.455L28.3768 12.9037L27.8318 12.4806L28.7174 11.6345L28.0362 11.0704L28.9218 10.3652L28.3428 9.9069Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M0.651367 5.14728L1.60509 9.9069L0.991984 10.3652L1.87759 11.0704L1.19635 11.6345L2.11602 12.4806L1.53697 12.9037L2.83131 14.455L8.72397 12.6922L12.8795 9.06075L2.04789 0.740234L0.651367 5.14728Z",
    fill: "#763E1A",
    stroke: "#763E1A",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M27.086 14.4576L21.2274 12.6948L22.9986 15.4801L20.3418 20.8038L23.8501 20.7685H29.0616L27.086 14.4576Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M8.72187 12.6948L2.82921 14.4576L0.887695 20.7685H6.09913L9.57341 20.8038L6.95067 15.4801L8.72187 12.6948Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M16.6938 15.7602L17.0684 9.06147L18.7715 4.2666H11.1758L12.8789 9.06147L13.2535 15.7602L13.3898 17.8756V23.0935H16.5235V17.8756L16.6938 15.7602Z",
    fill: "#F5841F",
    stroke: "#F5841F",
    strokeWidth: 0.340616,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetaMask);
export default __webpack_public_path__ + "static/media/meta-mask.574f6b8dd4e1ea420974a16c91ed2796.svg";
export { ForwardRef as ReactComponent };